export default "__VITE_ASSET__DtJEv5EU__"